export enum RatingTypeEnum {
    NRR = 1,
    ProtectionFactor = 2
}